/**
 * Homepage news slider
 */
export const homepageSlider = () => {
  (function ($) {
    if($('#homepageNewsSlider').length === 0) {
      return;
    }

    $('#homepageNewsSlider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 966,
          settings: {
            dots: true,
            arrows: false,
            infinite: true
          }
        },
      ]
    })
  })(jQuery);
}